import * as _ from 'lodash';
import {ACTIVATE_MINI_GAME, END_YEAR, INCREMENT_YEAR, START_YEAR, TEST_ANNUAL_TARGETS} from "../actions/action";
import {put, select, takeEvery} from "redux-saga/effects";
import {AnyAction} from "redux";
import {getSeasonsData, getYearsData, IMiniGame, ISeason, IYear} from "../../data/data";
import {showGameOverModal, showModal} from "../actions/modals";
import {MODALS} from "../reducers/modal";
import {clearOutageID, setOutageID} from "../actions/outages";
import {resetTimer, startTimer, stopTimer} from "../actions/timer";
import {getPreviousYearData, getYearData, getYearIndex} from '../reducers/year';
import {setEnergyDemand} from '../actions/energy/setEnergyDemand';
import {setCarbonTarget} from '../actions/carbon/setCarbonTarget';
import {showNextYearEndQuestion} from '../actions/questions/questions';
import {PowerSourceCounts} from '../reducers/savedPowerSourceCounts';
import {countPowerSourcesByType} from '../reducers/powerSources';
import {savePowerSourceCounts} from '../actions/power-sources/savePowerSourceCounts.ts';
import {updateScore} from '../actions/score';
import {endYear, incrementYear, setSeason, startYear} from '../actions/calendar/year';
import {isYearAlreadyComplete} from '../reducers/calendar/isYearAlreadyComplete';
import {clearMiniGameID, setMiniGameID} from '../actions/mini-game/miniGame';
import {delay} from 'redux-saga';
import {getMiniGameData} from '../reducers/mini-game/miniGame';
import {SCREENS} from '../reducers/screen';
import {setScreen} from '../actions/screens';
import {clearDeprecateType, deprecateSourceType, removeDeprecatedStations} from '../actions/power-sources/deprecate';


/**
 * handle outages
 */
export default function* handleCalendar()
{
    // yield takeEvery(NEXT_SEASON, onNextSeason);
    // yield takeEvery(RESET_SEASON, onResetSeason);
    // yield takeEvery(TRIGGER_SEASONAL_CONTENT, onTriggerSeasonalContent);
    // yield takeEvery(INCREMENT_YEAR, onTriggerSeasonalContent);
    yield takeEvery(START_YEAR, onStartYear);
    yield takeEvery(END_YEAR, onEndYear);
    yield takeEvery(INCREMENT_YEAR, onIncrementYear);
    yield takeEvery(TEST_ANNUAL_TARGETS, onTestAnnualTargets);
    yield takeEvery(ACTIVATE_MINI_GAME, onActivateMiniGame);
}


/**
 * step on to the next year
 * @param {AnyAction} action
 */
function* onStartYear(action: AnyAction)
{
    //  get the current year index and data

    const year_index: number = yield select(getYearIndex);
    const year_data: IYear = yield select(getYearData);

    // console.group('onStartYear');
    // console.log('year_index', year_index);
    // console.log('year_data', year_data);

    //  save the current number of each type of power sources;
    //  we may want to refer to this at the year end to see what changes there have been

    const power_source_counts: PowerSourceCounts = yield select(countPowerSourcesByType);

    yield put(savePowerSourceCounts(power_source_counts));

    //  update the game with properties from the year

    const {demand} = year_data;

    if (demand) yield put(setEnergyDemand(demand));

    const {'carbon-target':carbon_target} = year_data;

    if (carbon_target) yield put(setCarbonTarget(carbon_target));


    // const {'remove-sources':remove_source_type} = year_data;
    //
    // if (remove_source_type) yield put(removePowerSourceType(remove_source_type));
    //

    //  handle outages

    const {outage} = year_data;


    // console.log('outage', outage);
    // console.groupEnd();

    yield put(outage ? setOutageID(outage) : clearOutageID());

    //  handle deprecations

    const previous_year: IYear = yield select(getPreviousYearData);
    const {deprecate:odeprecate} = previous_year || {} as IYear;

    if (odeprecate)
    {
        yield put(removeDeprecatedStations(odeprecate));
        yield put(clearDeprecateType());
    }

    const {deprecate} = year_data;


    yield put(deprecate ? deprecateSourceType(deprecate) : clearDeprecateType());


    //  handle mini games

    const {'mini-game': mini_game} = year_data;

    // console.log('mini_game', mini_game);

    if (mini_game) yield put(setMiniGameID(mini_game));





    // //  get the current season
    //
    // const season_id: string = yield select(getSeasonID);
    //
    // //  find the next season in the list
    //
    // const seasons: ISeason[] = getSeasonsData();
    //
    // const current_index: number = _.findIndex(seasons, ['id', season_id]);
    // const new_index: number = (current_index + 1) % 4;
    //
    // const new_season_id: string = _.get(seasons, `[${new_index}].id`);
    //
    yield put(resetTimer());
    yield put(startTimer());

    // yield put(setSeason(new_season_id));

    yield put(showModal(MODALS.YEAR));
    //
    // //  when we get to spring, open the game UI panel
    //
    // if (new_season_id === 'spring') yield put(openResultsPanel());
}



/**
 * when we move on to the next year
 * @param {AnyAction} action
 */
function* onEndYear(action: AnyAction)
{
    //  at the end of a year, we need to:



    //  - assess how well they've done in terms of the annual target

    yield put(updateScore());
    yield put(clearMiniGameID());
    yield put(setScreen(SCREENS.GAME));

    const years_data: IYear[] = yield select(getYearsData);
    const year_index: number = yield select(getYearIndex);


    const year: IYear = yield select(getYearData);
    const {deprecate} = year;

    // console.group('onEndYear');
    // console.log('year', year);
    // console.log('deprecate', deprecate);
    // console.groupEnd();

    if (year['year-end'] || year['year-end-success'])
    {
        yield put(showModal(MODALS.YEAR_END_STATUS));
    }
    else
    {
        yield put(incrementYear());
    }

    // // if (year_index < 1)
    // if (year_index < years_data.length - 1)
    // {
    //     //  ask a question before moving on to the next year
    //
    //     // showYearEndQuestion
    //
    //
    //
    //     // yield put(showNextYearEndQuestion());
    // }
    // else
    // {
    //     yield put(showGameOverModal())
    // }





    // const year_index: number = yield select(getYearIndex);
    // const year_data: IYear = yield select(getYearData);
    //
    // console.group('onIncrementYear');
    // console.log('year_index', year_index);
    // console.log('year_data', year_data);
    // console.groupEnd();
    //
    // yield put(resetTimer());
    // yield put(startYear());
    //
    //
    // const n_years: number = getYearsData().length;
    //
    // //TODO  if we've reached the end of the alloted time, let's end the game
    //
    // // if (year_index === n_years)
}



/**
 * when we move on to the next year
 * @param {AnyAction} action
 */
function* onIncrementYear(action: AnyAction)
{
    const year_index: number = yield select(getYearIndex);
    const year_data: IYear = yield select(getYearData);

    // console.group('onIncrementYear');
    // console.log('year_index', year_index);
    // console.log('year_data', year_data);
    // console.groupEnd();

    yield put(resetTimer());
    yield put(startYear());


    const n_years: number = getYearsData().length;

    //TODO  if we've reached the end of the alloted time, let's end the game

    // if (year_index === n_years)
}


function* onTestAnnualTargets(action: AnyAction)
{
    const is_complete: boolean = yield select(isYearAlreadyComplete);

    if (is_complete) yield put(endYear());
}


function* onActivateMiniGame(action: AnyAction)
{
    const mini_game_data: IMiniGame = yield select(getMiniGameData);

    // console.group('onActivateMiniGame');
    // console.log('mini_game_data', mini_game_data);
    // console.groupEnd();

    if (! mini_game_data) return;

    yield delay(500);
    yield put(showModal(MODALS.EVENT));
}


// /**
//  * step on to the next season
//  * @param {AnyAction} action
//  */
// function* onNextSeason(action: AnyAction)
// {
//     //  get the current season
//
//     const season_id: string = yield select(getSeasonID);
//
//     //  find the next season in the list
//
//     const seasons: ISeason[] = getSeasonsData();
//
//     const current_index: number = _.findIndex(seasons, ['id', season_id]);
//     const new_index: number = (current_index + 1) % 4;
//
//     const new_season_id: string = _.get(seasons, `[${new_index}].id`);
//
//     yield put(resetTimer());
//     yield put(setSeason(new_season_id));
//     yield put(showModal(MODALS.SEASON));
//
//     //  when we get to spring, open the game UI panel
//
//     if (new_season_id === 'spring') yield put(openResultsPanel());
// }
//
//
// /**
//  * reset the seasons
//  * @param {AnyAction} action
//  */
// function* onResetSeason(action: AnyAction)
// {
//     yield put(setSeason(null));
// }
//
//
// /**
//  * reset the seasons
//  * @param {AnyAction} action
//  */
// function* onTriggerSeasonalContent(action: AnyAction)
// {
//     //  get the current season id
//
//     const season: string = yield (select(getSeasonID));
//
//     switch (season)
//     {
//         case 'spring':
//         default:
//
//             //  show a hint
//
//             yield put(chooseGeneralHint());
//
//             break;
//
//         case 'summer':
//
//             //  trigger an event
//
//             yield put(chooseRelevantEvent());
//
//             break;
//
//         case 'autumn':
//
//             //  trigger an outage
//
//             yield put(chooseRelevantOutage());
//
//             break;
//
//         case 'winter':
//
//             //  display year-end results
//
//             yield put(openResultsPanel());
//
//             break;
//     }
// }



// WEBPACK FOOTER //
// ./src/ts/store/sagas/handleCalendar.ts